export default function parseIntId(id) {
  const idInt = parseInt(id);
  if (isNaN(idInt)) {
    return 0;
  } else {
    return idInt;
  }
}
